import React, { useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Facilities from './components/Facilities';
import Pricing from './components/Pricing';
import Events from './components/Events';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './styles/index.css';

export default function App() {
  useEffect(() => {
    // Update meta tags dynamically for better SEO
    document.title = 'Rudra Sports - Badminton, Box Cricket & Gym | Book Now via Playo';
    
    // Set canonical URL
    const link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      const canonical = document.createElement('link');
      canonical.rel = 'canonical';
      canonical.href = 'https://rudrasports.com';
      document.head.appendChild(canonical);
    }

    // Add structured data for better search results
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.innerHTML = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'LocalBusiness',
      'name': 'Rudra Sports',
      'description': 'Premium sports facility with badminton courts, box cricket arena, and modern gym',
      'url': 'https://rudrasports.com',
      'areaServed': '[Your City]',
      'priceRange': '₹₹',
      'openingHoursSpecification': {
        '@type': 'OpeningHoursSpecification',
        'dayOfWeek': ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
        'opens': '06:00',
        'closes': '22:00'
      }
    });
    document.head.appendChild(script);

  }, []);

  return (
    <>
      <Header />
      <main>
        <Hero />
        <Facilities />
        <Pricing />
        <Events />
        <About />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
